<template>
  <div class="page-container">
    <el-card class="box-card" :body-style="{ flex: 1, overflow: 'auto' }">
      <template #header>
        <div class="card-header">
          <span>{{$t('activity.detail.editAct')}}</span>
          <div>
            <el-button class="button" type="danger" size="small" @click="cancelEdit">{{$t('activity.detail.back')}}</el-button>
            <el-button v-if="true || detailform.status!==$t('activity.detail.ended')" class="button" type="primary" size="small" @click="saveEdit">{{$t('activity.detail.save')}}</el-button>
          </div>
        </div>
      </template>
      <el-form ref="detailformRef" class="dialog-form" :model="detailform" :rules="detailformRules" :label-width="curLang == 'zh-CN' ? '120px' : curLang == 'en-US' ? '170px' : '210px'">
        <el-form-item :label="$t('activity.detail.titleName')" prop="name">
          <el-input v-if="newType" v-model="detailform.name" clearable :placeholder="$t('activity.detail.title')"></el-input>
          <span v-else>{{detailform.name}}</span>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.location')">
          {{detailform.location}}
        </el-form-item>
        <el-form-item :label="$t('activity.detail.date')">
          {{detailform.startDate + $t('activity.detail.to') + detailform.endDate}}
        </el-form-item>
        <el-form-item :label="$t('activity.detail.time')" prop="startTime">
          <!-- <div>
            <el-button type="text" size="small" @click="addActivityDate">添加日期时间</el-button>
          </div> -->
          <el-space v-for="(item,index) in activityDateTime" :key="index" style="margin:5px 0">
            <!-- <el-date-picker
              v-model="item.date"
              type="daterange"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker> -->
            <el-time-picker 
              v-model="item.time"
              is-range
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              :range-separator="$t('activity.detail.to')"
              :start-placeholder="$t('activity.detail.startTime')"
              :end-placeholder="$t('activity.detail.endTime')"
              clearable
            >
            </el-time-picker>
            <!-- <i class="el-icon-close" style="cursor: pointer;padding:12px;" @click="deleteActivityDate(index)"></i> -->
          </el-space>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.showFrontend')" prop="isShow">
          <el-switch v-model="detailform.isShow" :active-text="$t('activity.detail.publicVisible')" :inactive-text="$t('activity.detail.internalVisible')" style="margin-right: 10px;" />
        </el-form-item>
        <el-form-item :label="$t('activity.detail.listImg')" prop="icon">
          <Upload
            v-model="detailform.icon"
            list-type="picture-card"
            type="image"
            :limit="1"
            :auto-upload="true"
            :before-upload="beforeUpload"
            :file-list="iconList"
          >
            <el-button type="text">{{$t('activity.detail.uploadImg')}}</el-button>
            <template #tip>
              <div class="el-upload__tip">{{$t('activity.detail.imgLimit')}}<span style="color:red;">{{$t('activity.detail.imgSize300')}}</span>
              </div>
            </template>
          </Upload>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.titleImg')" prop="picture">
          <Upload
            v-model="detailform.picture"
            list-type="picture-card"
            type="image"
            :auto-upload="true"
            :before-upload="beforeUpload"
            :file-list="pictureList"
          >
            <el-button type="text">{{$t('activity.detail.uploadImg')}}</el-button>
            <template #tip>
              <div class="el-upload__tip">{{$t('activity.detail.imgLimit')}}<span style="color:red;">{{$t('activity.detail.imgSize660')}}</span>
              </div>
            </template>
          </Upload>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.actContent')" prop="content">
          <div class="el-editor" style="">
            <Editor ref="activeEditor" v-model="detailform.content" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.extLinkUrl')" prop="content">
          <el-input v-model="detailform.externalLink" clearable :placeholder="$t('activity.detail.extUrl')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('activity.detail.extLinkDesc')" prop="content">
          <el-input v-model="detailform.externalLinkContent" clearable :placeholder="$t('activity.detail.extLinkText')"></el-input>
        </el-form-item>
        <template v-if="activityType == 2">
          <el-form-item :label="$t('activity.detail.fissionPoster')" prop="poster">
            <Upload
              v-model="detailform.poster"
              list-type="picture-card"
              type="image"
              :auto-upload="true"
              :before-upload="beforeUpload"
              :file-list="posterList"
            >
              <el-button type="text">{{$t('activity.detail.uploadImg')}}</el-button>
              <template #tip>
                <div class="el-upload__tip">{{ $t('activity.detail.imgLimit') }}</div>
              </template>
            </Upload>
          </el-form-item>
          <el-form-item :label="`${$t('activity.detail.customer')}：`" >
            <el-select v-model="detailform.unionCustomers" :placeholder="$t('activity.detail.customer')" :remote-method="companyQuery" multiple filterable remote clearable>
              <el-option
                v-for="(item) in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('activity.detail.jointImg')">
            <Upload
              v-model="detailform.unionPicture"
              list-type="picture-card"
              type="image"
              :auto-upload="true"
              :before-upload="beforeUpload"
              :file-list="unionPictureList"
            >
              <el-button type="text">{{ $t('activity.detail.uploadImg') }}</el-button>
              <template #tip>
                <div class="el-upload__tip">{{ $t('activity.detail.imgLimitDesc') }}</div>
              </template>
            </Upload>
          </el-form-item>
        </template>
        <template v-if="activityType == 8">
          <el-form-item :label="$t('activity.detail.shareWithOthers')" prop="isShare">
            <el-radio-group v-model="detailform.isShare" >
              <el-radio :label="1">{{$t('activity.detail.yes')}}</el-radio>
              <el-radio :label="0">{{ $t('activity.detail.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('activity.detail.showBtn')" prop="buttonContent">
            <template v-for="(item, index) in buttons" :key="index">
              <div style="display: flex;align-items: center;">
                <el-input style="margin: 0 10px 10px 0;" v-model="item.name" clearable :placeholder="$t('activity.detail.btnName')"></el-input>
                <el-input style="margin: 0 10px 10px 0;" v-model="item.link" clearable :placeholder="$t('activity.detail.btnLink')"></el-input>
                <i class="el-icon-delete" style="padding: 0 10px;" @click="deleteBtn(index)"></i>
              </div>
            </template>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="addNewBtn">{{$t('activity.detail.addBtn')}}</el-button>
          </el-form-item>
        </template>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { reactive, toRefs, watch, computed } from "vue"
import { useRouter, useRoute } from 'vue-router'

import { ElMessage } from "element-plus";
// import { formatTime } from "../../common/utils";
import Editor from '@/components/editor'
import { urlMap } from '@/common/config';
import { uploadFile } from "@/utils/request";
import Upload from '@/components/upload'
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex"

export default {
  components: {
    Editor,
    Upload
  },
  mixins: [common],
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const newTypeList = [t('activity.detail.newProduct'),t('activity.detail.pointsExchange'), t('activity.detail.digitalMarketing')]
    const router = useRouter()
    const route = useRoute()
    const activityId = route.query.id
    const activityType = route.query.type
    const state = reactive({
      newType: newTypeList.includes(activityType),
      activeEditor: null,
      detailData: {},
      detailformRef: null,
      detailform: {
        id: activityId,
        name: '',
        // type: '',
        picture: '',
        icon: '',
        location: '',
        startDate: '',
        endDate: '',
        content: '', // 内容
        externalLink: '', // 外部链接地址
        externalLinkContent: '', // 外部链接文案
        poster: '', // 海报
        unionCustomers: [],
        unionPicture: '',
        status: '',
        isShow: '',
        isShare: '', // 显示分享
        buttonContent: '', // 显示按钮
      },
      buttons: [{
        name: '',
        link: '',
      }],
      activityDateTime: [{
        date: [],
        time: []
      }],
      upload: null,
      uploadRef: null,
      iconList: [],
      pictureList: [],
      posterList: [],
      unionPictureList: [],
      uploadFile: urlMap['uploadFile'],
      companyList: [],
      curLang: computed(() => store.state.lang)
    })

    const detailformRules = reactive({
      name: {
        required: true,
        message: t('activity.detail.titleRequired'),
        trigger: 'blur',
      },
      startTime: {
        required: true,
        message: t('activity.detail.timeRequired'),
        trigger: 'blur',
      },
      icon: {
        required: true,
        message: t('activity.detail.listImgRequired'),
        trigger: 'blur',
      },
      picture: {
        required: true,
        message: t('activity.detail.titleImgRequired'),
        trigger: 'blur',
      },
      content: {
        required: true,
        message: t('activity.detail.contentRequired'),
        trigger: 'blur',
      },
      isShare: {
        required: true,
        message: t('activity.detail.shareChoice'),
        trigger: 'blur',
      },
      buttonContent: {
        // required: true,
        message: t('activity.detail.enterBtnName'),
        trigger: 'blur',
        validator: (rule, value, callback) => {
          for(let btn of state.buttons) {
            if (!btn.name) {
              callback(t('activity.detail.enterBtnName'))
              return
            }
          }
          callback()
        }
      },
    })
    watch(
      () => state.activityDateTime, 
      (cur, pre) => {
        console.log(t('activity.detail.newValue'), cur, t('activity.detail.oldValue'), pre);
        if (state.activityDateTime[0]) {
          // state.detailform.startDate = state.activityDateTime[0].date[0]
          // state.detailform.endDate = state.activityDateTime[0].date[1]
          state.detailform.startTime = state.activityDateTime[0].time[0]
          state.detailform.endTime = state.activityDateTime[0].time[1]
        }
      },
      { deep: true }
    )
    watch(
      () => state.buttons, 
      (cur) => {
        state.detailform.buttonContent = JSON.stringify(cur)
        console.log('buttonContent', state.detailform.buttonContent)
      },
      { deep: true }
    )

    const getData = async () => {
      try {
        const res = await request("getActivityDetail", {
          id: activityId
        })
        state.detailData = res
        console.log('getActivityDetail', res)
        // console.log('activityDateTime', state.activityDateTime)
        state.activityDateTime[0] = {
          date: res.startDate && res.endDate ? [res.startDate, res.endDate]:[],
          time: res.startTime && res.endTime ? [res.startTime, res.endTime]:[]
        }
        state.companyList = res.unionCustomers || []
        res.unionCustomers = state.companyList.map((item) => {
          return item.id
        })
        for (let key of Object.keys(state.detailform)) {
          state.detailform[key] = res[key]
        }
        state.iconList = state.detailform.icon ? [{name: 'icon', url: state.detailform.icon}]:[]
        state.pictureList = state.detailform.picture ? [{name: 'picture', url: state.detailform.picture}]:[]
        state.posterList = state.detailform.poster ? [{name: 'poster', url: state.detailform.poster}]:[]
        state.unionPictureList = state.detailform.unionPicture ? [{name: 'unionPicture', url: state.detailform.unionPicture}]:[]
        state.buttons = state.detailform.buttonContent ? JSON.parse(state.detailform.buttonContent) : []
      } catch (error) {
        console.error(error)
      }
    }
    const companyQuery = async (name) => {
      try {
        if (!name) return
        const res = await request('getCustomerList', {
          customerName: name
        })
        state.companyList = res.slice(0, 30)
      } catch (error) {
        console.error(error)
      }
    }
    const addActivityDate = () => {
      state.activityDateTime.push({})
    }
    const deleteActivityDate = (index) => {
      state.activityDateTime.splice(index,1)
    }
    const beforeUpload = (file) => {
      if (file.size > 500000) {
        ElMessage({
          showClose: true,
          type: "warning",
          message: t('activity.detail.imgSizeLimit')
        })
        return false
      } else {
        return true
      }
    }
    const deleteBtn = (index) => {
      state.buttons.splice(index, 1)
    }
    const addNewBtn = () => {
      state.buttons.push({
        name: '',
        link: '',
      })
    }
    const saveEdit = async () => {
      console.log(state.detailform)
      try {
        state.detailformRef && await state.detailformRef.validate()
        console.log('saveEdit validate -->')
        await request('editActivity', state.detailform)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.detail.saveSuccess')
        })
        router.back()
      } catch (err) {
        console.error(err)
      }
    }
    const cancelEdit = () => {
      router.back()
      // state.activeEditor.getContent()
    }
    function uploadImg (params) {
      console.log('uploadImg', params)
      const formData = new FormData();
      formData.append('multipartFile', params.file)
      uploadFile(formData)
      .then((res) => {
        console.log('images_success', res)
        
      })
      .catch((err) => {
        console.log('images_err', err)
        
      })
    }
    getData()
    return {
      activityId,
      activityType,
      detailformRules,
      getData,
      ...toRefs(state),
      companyQuery,
      deleteBtn,
      addNewBtn,
      saveEdit,
      cancelEdit,
      beforeUpload,
      uploadImg,
      addActivityDate,
      deleteActivityDate
    };
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.box-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  z-index: 10;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>